<template>
    <div class="collapse" ref="collapse">
        <slot></slot>
    </div>
</template>
<script>

export default {
    name: 'collapse',
    components: {

    },
    props: {
        show: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {

        }
    },
    computed: {

    },
    mounted() {
        this.init();
    },
    methods: {
        init() {
            let el = this.$refs.collapse;
            if (el) {
                if (this.show) {
                    el.style.height = el.scrollHeight + 'px';
                } else {
                    el.style.height = '0';
                }
            }
        }
    },
    watch: {
        show: 'init'
    }
}
</script>
<style lang="scss" scoped>
.collapse {
    transition: height .3s ease-in-out;
    overflow: hidden;
}
</style>